module.exports = __webpack_public_path__ + "static/media/Common-area.5fbf3d7b.jpg";